import { render, staticRenderFns } from "./Chatroom.vue?vue&type=template&id=807c1d12&scoped=true"
import script from "./Chatroom.vue?vue&type=script&lang=js"
export * from "./Chatroom.vue?vue&type=script&lang=js"
import style0 from "./Chatroom.vue?vue&type=style&index=0&id=807c1d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807c1d12",
  null
  
)

export default component.exports